import {
  get,
  post,
  del,
} from '@/utils/request';

const url = 'vouchers';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id, data) {
  return post({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

export function getAvailableByStudentId(data) {
  return get({
    url: `${url}/available`,
    data,
  });
}
